import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSegment } from '../../../../../../hooks'
import { PeriodValue } from '../../../../../../types/periodValue'
import { useBankMatchesToolbarFilters } from '../../context/BankMatchesToolbarFiltersContext'

export const BankMatchesDateSelector = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { queryParams, setQueryParams } = useBankMatchesToolbarFilters()
  const { track } = useSegment()

  const queryParamPeriod = queryParams.period

  const handleChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      const encodedPeriodValue = encodePeriodValue(periodValue, organization.id)
      setQueryParams({ period: encodedPeriodValue })
      // eslint-disable-next-line @typescript-eslint/naming-convention
      track('XXX - Reconciliation Filter Applied (Client)', { filter_type: 'date_range' })
    },
    [organization, setQueryParams, track],
  )

  return <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handleChange} />
}
